/*
 * dk-ai-intent.js — CANDIDATE ONLY. Not installed. Not collecting.
 * Theme-side listener: classifies clicks on tel:/WhatsApp/Calendly links and publishes
 * a Shopify custom event `dk_ai_intent` with { intent, position } and nothing else.
 * It never exports href, phone number, link text, query string or form data.
 * It never cancels, blocks or redirects the click, and never navigates.
 * Scope: https://www.deankeating.com/pages/ai-business-coach and /pages/ai-in-action only.
 */
(function () {
  'use strict';

  var W = typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : null);
  if (!W || !W.document) return;
  if (W.__dkAiIntentInit) return; // guard double init
  W.__dkAiIntentInit = true;

  var HOST = 'www.deankeating.com';
  var PATHS = { '/pages/ai-business-coach': 1, '/pages/ai-in-action': 1 };
  var WA_HOSTS = { 'wa.me': 1, 'api.whatsapp.com': 1 };
  var CAL_HOSTS = { 'calendly.com': 1, 'www.calendly.com': 1 };
  var HERO_SELECTOR = '.dk-page-hero';

  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function inScope() {
    try {
      var l = W.location;
      if (!l || l.protocol !== 'https:' || l.hostname !== HOST) return false;
      var p = l.pathname || '';
      if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
      return has(PATHS, p);
    } catch (e) { return false; }
  }

  // Classify from the PARSED href. Returns 'phone' | 'whatsapp' | 'calendly' | null.
  function classify(rawHref) {
    if (typeof rawHref !== 'string' || !rawHref || rawHref.length > 2048) return null;
    var u;
    try { u = new URL(rawHref, W.location.href); } catch (e) { return null; }
    if (u.protocol === 'tel:') return 'phone';
    if (u.protocol === 'https:' || u.protocol === 'http:') {
      var h = u.hostname.toLowerCase();
      if (has(WA_HOSTS, h)) return 'whatsapp';
      if (has(CAL_HOSTS, h)) return 'calendly';
    }
    return null;
  }

  function consentOk() {
    try {
      var S = W.Shopify;
      return !!(S && S.customerPrivacy &&
        typeof S.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        S.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (e) { return false; }
  }

  function publish(intent, position) {
    try {
      var S = W.Shopify;
      if (!S || !S.analytics || typeof S.analytics.publish !== 'function') return;
      var r = S.analytics.publish('dk_ai_intent', { intent: intent, position: position });
      if (r && typeof r.then === 'function') r.then(null, function () {}); // swallow rejection
    } catch (e) { /* silent */ }
  }

  function onClick(e) {
    try {
      if (!e || e.isTrusted === false) return;
      if (!inScope()) return;
      var t = e.target;
      if (t && t.nodeType === 3) t = t.parentElement || t.parentNode;
      if (!t || typeof t.closest !== 'function') return;
      var a = t.closest('a[href]');
      if (!a) return;
      var intent = classify(a.href || (a.getAttribute && a.getAttribute('href')));
      if (!intent) return;
      if (!consentOk()) return; // fail closed; nothing buffered for later
      var position = a.closest(HERO_SELECTOR) ? 'hero' : 'general';
      publish(intent, position);
    } catch (err) { /* silent: never disturb the click */ }
  }

  // capture phase so a page handler calling stopPropagation cannot hide the click
  W.document.addEventListener('click', onClick, true);
})();
